interface InstructorSelectorProps {
  selected: string;
  onChange: (name: string) => void;
}

const instructors = [
  {
    id: "destiny",
    name: "Destiny, RN",
    title: "Lead Instructor",
    photo: "https://static.readdy.ai/image/99ee4fd5eb46fc3e1cae300823aab6a6/d0af4d7d162fec6e5a578befc0a6cad3.jpeg",
    courses: "BLS \u00b7 ACLS \u00b7 PALS \u00b7 Heartsaver",
    badge: "Founder & Lead",
  },
  {
    id: "nathaniel",
    name: "Nathaniel, RN",
    title: "CPR Instructor",
    photo: "https://static.readdy.ai/image/99ee4fd5eb46fc3e1cae300823aab6a6/8beb49ca74db3e6233abe830acda7cca.jpeg",
    courses: "BLS \u00b7 Heartsaver \u00b7 First Aid",
    badge: "RN Instructor",
  },
];

export default function InstructorSelector({ selected, onChange }: InstructorSelectorProps) {
  const noneSelected = selected === "";

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-2 mb-1">
        <i className="ri-nurse-line text-brand-gold text-sm" />
        <label className="text-white font-semibold text-sm">
          Choose Your Instructor
        </label>
        {noneSelected && (
          <span
            className="ml-auto text-xs font-bold px-2 py-0.5 rounded-full"
            style={{
              background: "rgba(239,68,68,0.15)",
              border: "1px solid rgba(239,68,68,0.35)",
              color: "#fca5a5",
            }}
          >
            Required
          </span>
        )}
      </div>

      <div className="grid grid-cols-2 gap-3">
        {instructors.map((inst) => {
          const isSelected = selected === inst.id;
          return (
            <button
              key={inst.id}
              type="button"
              onClick={() => onChange(inst.id)}
              className="relative flex flex-col items-center gap-2 py-4 px-3 rounded-xl cursor-pointer transition-all duration-300 text-center"
              style={{
                background: isSelected
                  ? "linear-gradient(135deg, rgba(107,70,193,0.3), rgba(76,29,149,0.4))"
                  : noneSelected
                  ? "rgba(255,255,255,0.06)"
                  : "rgba(255,255,255,0.04)",
                border: isSelected
                  ? "1.5px solid rgba(212,175,55,0.7)"
                  : noneSelected
                  ? "1px solid rgba(255,255,255,0.18)"
                  : "1px solid rgba(255,255,255,0.1)",
                boxShadow: isSelected ? "0 0 20px rgba(107,70,193,0.25)" : "none",
              }}
            >
              {/* Selected check */}
              {isSelected && (
                <div
                  className="absolute top-2 right-2 w-5 h-5 flex items-center justify-center rounded-full"
                  style={{ background: "linear-gradient(135deg, #D4AF37, #b8952e)" }}
                >
                  <i className="ri-check-line text-black text-xs" />
                </div>
              )}

              {/* Unselected hint dot */}
              {noneSelected && (
                <div
                  className="absolute top-2 right-2 w-5 h-5 flex items-center justify-center rounded-full"
                  style={{
                    background: "rgba(255,255,255,0.06)",
                    border: "1.5px dashed rgba(255,255,255,0.25)",
                  }}
                />
              )}

              {/* Photo */}
              <div
                className="w-16 h-16 rounded-full overflow-hidden shrink-0"
                style={{
                  border: isSelected
                    ? "2px solid rgba(212,175,55,0.8)"
                    : "2px solid rgba(255,255,255,0.15)",
                }}
              >
                <img
                  src={inst.photo}
                  alt={inst.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Info */}
              <div>
                <p className="text-white font-bold text-xs leading-snug">{inst.name}</p>
                <p
                  className="text-xs font-semibold mt-0.5"
                  style={{ color: isSelected ? "#D4AF37" : "rgba(255,255,255,0.4)" }}
                >
                  {inst.title}
                </p>
                <p className="text-white/35 text-xs mt-1 leading-snug">{inst.courses}</p>
              </div>
            </button>
          );
        })}
      </div>

      {noneSelected ? (
        <p
          className="text-center text-xs py-2 px-3 rounded-lg"
          style={{
            background: "rgba(255,255,255,0.04)",
            border: "1px dashed rgba(255,255,255,0.15)",
            color: "rgba(255,255,255,0.4)",
          }}
        >
          <i className="ri-cursor-line mr-1" />
          Tap a card above to select your instructor
        </p>
      ) : (
        <p
          className="text-center text-xs py-2 px-3 rounded-lg"
          style={{
            background: "rgba(212,175,55,0.07)",
            color: "rgba(212,175,55,0.8)",
          }}
        >
          <i className="ri-shield-check-line mr-1" />
          All instructors are Registered Nurses &amp; AHA-aligned
        </p>
      )}
    </div>
  );
}
